import { render } from "./IconMaskedLock.vue?vue&type=template&id=4758eb39"
import script from "./IconMaskedLock.vue?vue&type=script&lang=ts"
export * from "./IconMaskedLock.vue?vue&type=script&lang=ts"
script.render = render

export default script